<template>
  <div class="campaign-preview">
    <h3>{{ data.name }}</h3>
    <hr style="border: none;border-top: 1px solid #C8D2D2;margin: 0 0px;">
    <div class="campaign-box-options">
      <div class="campaign-button preview" @click="preview"><i class="fas fa-eye"></i> Preview Campaign</div>
      <div class="campaign-button get-code" v-if="data.is_active" @click="qr"><i class="fas fa-qrcode"></i> Show QR Code</div>
      <div class="campaign-button edit" @click="edit_item"><i class="fas fa-edit"></i> Edit</div>
      <div class="campaign-button stop" v-if="data.is_active" @click="stopCampaign"><i class="fas fa-stop"></i> Stop Campaign</div>
      <div class="campaign-button resume" v-if="!data.is_active" @click="startCampaign"><i class="fas fa-play"></i> Resume Campaign</div>
      <div class="campaign-button delete" @click="delete_item"><i class="fas fa-trash-alt"></i> Delete</div>
    </div>

    <b-modal v-model="show_qr" title="QR Code" hide-footer>
      <template #modal-header-close>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
          <g clip-path="url(#clip0_143_787)">
            <path d="M11 0.34375C5.11328 0.34375 0.34375 5.11328 0.34375 11C0.34375 16.8867 5.11328 21.6562 11 21.6562C16.8867 21.6562 21.6562 16.8867 21.6562 11C21.6562 5.11328 16.8867 0.34375 11 0.34375ZM16.225 13.7973C16.427 13.9992 16.427 14.3258 16.225 14.5277L14.5234 16.225C14.3215 16.427 13.9949 16.427 13.793 16.225L11 13.4062L8.20273 16.225C8.00078 16.427 7.67422 16.427 7.47227 16.225L5.775 14.5234C5.57305 14.3215 5.57305 13.9949 5.775 13.793L8.59375 11L5.775 8.20273C5.57305 8.00078 5.57305 7.67422 5.775 7.47227L7.47656 5.7707C7.67852 5.56875 8.00508 5.56875 8.20703 5.7707L11 8.59375L13.7973 5.775C13.9992 5.57305 14.3258 5.57305 14.5277 5.775L16.2293 7.47656C16.4312 7.67852 16.4312 8.00508 16.2293 8.20703L13.4062 11L16.225 13.7973Z" fill="#F08028"/>
          </g>
          <defs>
            <clipPath id="clip0_143_787">
              <rect width="22" height="22" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </template>
      <p class="pcore" @click="link_click">
        <qr-code ref="qr_code" :text="qr_url" error-level="H"
                 :size="size" bg-color="transparent" class="qrcode"></qr-code>
      </p>
      <div class="downloadqr" v-if="data.is_active" @click="qr_download">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <g clip-path="url(#clip0_143_790)">
              <path d="M9.28125 0H12.7188C13.2902 0 13.75 0.459766 13.75 1.03125V8.25H17.5184C18.2832 8.25 18.6656 9.17383 18.1242 9.71523L11.5887 16.2551C11.2664 16.5773 10.7379 16.5773 10.4156 16.2551L3.87148 9.71523C3.33008 9.17383 3.7125 8.25 4.47734 8.25H8.25V1.03125C8.25 0.459766 8.70977 0 9.28125 0ZM22 16.1562V20.9688C22 21.5402 21.5402 22 20.9688 22H1.03125C0.459766 22 0 21.5402 0 20.9688V16.1562C0 15.5848 0.459766 15.125 1.03125 15.125H7.33477L9.44023 17.2305C10.3039 18.0941 11.6961 18.0941 12.5598 17.2305L14.6652 15.125H20.9688C21.5402 15.125 22 15.5848 22 16.1562ZM16.6719 19.9375C16.6719 19.4648 16.2852 19.0781 15.8125 19.0781C15.3398 19.0781 14.9531 19.4648 14.9531 19.9375C14.9531 20.4102 15.3398 20.7969 15.8125 20.7969C16.2852 20.7969 16.6719 20.4102 16.6719 19.9375ZM19.4219 19.9375C19.4219 19.4648 19.0352 19.0781 18.5625 19.0781C18.0898 19.0781 17.7031 19.4648 17.7031 19.9375C17.7031 20.4102 18.0898 20.7969 18.5625 20.7969C19.0352 20.7969 19.4219 20.4102 19.4219 19.9375Z" fill="#006495"/>
            </g>
            <defs>
              <clipPath id="clip0_143_790">
                <rect width="22" height="22" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>Download QR Code</div>

    </b-modal>
<!--    <div v-if="show_qr" class="qr-field w-100" @click="link_click">

    </div>-->
  </div>
</template>

<script>
import ScratchPreview from '../CreateCampaign/components/ScratchPreview'
export default {
  props: {
    data: {
      type: Object
    },
    callback: {
      type: Function
    },
    setPostInfo: {
      type: Function
    }
  },
  components: {
    ScratchPreview
  },
  mounted () {
    /*yourls.connect('https://authlocal.com/sample-public-api.php', {
      username: 'Demygo',
      password: 'alper90'
    })
    yourls.shorten(this.qr_url, (result, response) => {
      console.log(result.shorturl, response)
      //=> "https://example.com/abc123"
      console.log(result.title)
      //=> "https://github.com/neocotic/yourls-api"
      console.log(result.url.keyword)
      //=> "abc123"
    })
    yourls.disconnect()*/
  },
  computed: {
    qr_url () {
      const domain = window.location.origin
      return `${domain}/scratch/${this.data.slug}`
    },
    short_qr_url () {
      return `https://authlocal.com/${this.data.slug}`
    },
    label_style () {
      if (this.campaign_theme.labels) {
        return `color: ${this.campaign_theme.labels.color}; font-size: ${this.campaign_theme.labels.size}px; font-weight: ${this.campaign_theme.labels.weight};`
      } else {
        return ''
      }
    },
    main_style () {
      if (this.campaign_theme) {
        if (this.isObject(this.campaign_theme.main)) {
          return `background: url(${this.getImage(this.campaign_theme.main.url)})`
        } else if (this.campaign_theme.main !== '') {
          return `background: ${this.campaign_theme.main}`
        }
      }
      return ''
    },
    award_style () {
      if (this.campaign_theme.award) {
        return `color: ${this.campaign_theme.award.color}; font-size: ${this.campaign_theme.award.size}px; font-weight: ${this.campaign_theme.award.weight};`
      } else {
        return ''
      }
    },
    slogan_style () {
      if (this.campaign_theme.slogan) {
        return `color: ${this.campaign_theme.slogan.color}; font-size: ${this.campaign_theme.slogan.size}px; font-weight: ${this.campaign_theme.slogan.weight};`
      } else {
        return ''
      }
    },
    post_detail () {
      return this.$store.state.post_detail
    },
    campaign_theme () {
      return this.$store.state.campaign_theme
    }
  },
  data () {
    return {
      show_qr: false,
      short_url: '',
      show_preview: false,
      size: 1000,
      preview_switch: false,
      showScratch: true,
      name: '',
      logo_id: '',
      title: '',
      offer: '',
      campaign_image_id: '',
      fieldnames: [
        {
          name: 'Name',
          type: 'text',
          code: 'name',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          type: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          type: 'email',
          value: false
        },
        {
          name: 'Birthday',
          code: 'birthday',
          type: 'date',
          value: false
        },
        {
          name: 'ZIP Code',
          code: 'address',
          type: 'text',
          value: false
        }
      ],
      fieldList: ['email'],
      prizeList: []
    }
  },
  name: 'CardItem',
  methods: {
    getImage (url) {
      return `https://restapi.authorizelocal.com/api/posts/photo/${url}`
    },
    isObject (a) {
      return (!!a) && (a.constructor === Object)
    },
    preview () {
      if (!this.show_preview) {
        this.$store.commit('SET_POST_DETAIL', this.data)
        this.setPostInfo()
        this.show_preview = true
      } else {
        this.show_preview = false
      }
    },
    link_click () {
      //const routeData = this.$router.resolve({name: 'scratch', params:{slug: this.data.slug}})
      window.open(this.qr_url, '_blank')
    },
    qr (item) {
      this.show_qr = !this.show_qr
      console.log('edit', item)
    },
    qr_download () {
      this.show_qr = true
      setTimeout(() => {
        console.log('download qr', this.$refs.qr_code.$el.children[1].currentSrc)
        let ImageBase64 = this.$refs.qr_code.$el.children[1].currentSrc
        ImageBase64 = ImageBase64.split('base64,')[1]
        const a = document.createElement('a')

        const byteCharacters = atob(ImageBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)


        const blob = new Blob([byteArray], {type: 'octet/stream'})
        a.href = window.URL.createObjectURL(blob)
        a.download = 'qr_code.png'
        a.click()
      }, 500)

    },
    edit_item () {
      console.log('edit', this.data)
      this.$router.push({ name: 'edit-campaign', params: {id: this.data.slug}})
    },
    delete_item () {
      console.log('delete', this.data)
      this.openConfirm(() => {
        const obj = {
          id: this.data._id
        }
        this.$store.dispatch('deletePost', obj).then(response => {
          console.log(response)
          this.$vs.notify({
            title: 'Delete',
            text: 'Item deleted succesfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.callback()
        }).catch(err => { console.error(err) })
      }, () => {})
    },
    stopCampaign () {
      this.openStopConfirm(() => {
        const obj = {
          id: this.data._id,
          status: 'stop'
        }
        this.$store.dispatch('changeStatus', obj).then(response => {
          console.log(response)
          this.$vs.notify({
            title: 'Stop Campaing',
            text: 'Item stopped',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.callback()
        }).catch(err => { console.error(err) })
      }, () => {})
    },
    startCampaign () {
      this.openStartConfirm(() => {
        const obj = {
          id: this.data._id,
          status: 'resume'
        }
        this.$store.dispatch('changeStatus', obj).then(response => {
          console.log(response)
          this.$vs.notify({
            title: 'Resume Campaing',
            text: 'Item resumed',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.callback()
        }).catch(err => { console.error(err) })
      }, () => {})
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    openStopConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to stop this item?',
        accept,
        cancel
      })
    },
    openStartConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to resume this item?',
        accept,
        cancel
      })
    }
  }
}
</script>

<style lang="scss">
.qr-field {
  img {
    margin: 20px auto;
  }
}
.campaign-preview>h3 {
  color: var(--Main-Color-Main-100, #003451);
  font-variant-numeric: lining-nums proportional-nums;

  /* Heading Styles/H3 */
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */
}
.campaign-button {
  color: var(--Cold-Gray-Cold-Gray-40, #AEB8B8);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.32px;
}
.campaign-box-options {
  border: none;
}

.modal-content {
  border-radius: 20px;
  background: #FFF;
  box-shadow: 0px 0px 20px 0px rgba(0, 52, 81, 0.20);
  width: 371px;
  height: 432px;
}
.modal-header {
  width: 290px;
  margin: 10px 40px;
}
.modal-header .close {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 1px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin: 5px;
}
.modal-body {
  padding: 0 40px;
}
.qrcode {
  border-radius: 20px;
  background: #FFF;
  box-shadow: 0px 0px 20px 0px rgba(0, 52, 81, 0.15);
  display: flex;
  width: 240px;
  height: 240px;
  padding: 22px;
  justify-content: center;
  align-items: center;
}
.pcore {
  padding: 22px;
  cursor: pointer;
}
.downloadqr {
  gap: 16px;
  color: var(--Main-Color-Main-80, #006495);
  font-variant-numeric: lining-nums proportional-nums;

  /* Button Styles/Button Large */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.modal-title {
  color: var(--Main-Color-Main-100, #003451);
  font-variant-numeric: lining-nums proportional-nums;

  /* Heading Styles/H3 */
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */
}
.delete:hover {
  color: #F26464;
}
</style>
